import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CoreState, getCoreState } from '@rd/core/store/reducers';
import { NYDUS_NETWORK_API_BASE_URL } from '@rd/core/tokens/rd-lib.token';
import { Observable } from 'rxjs';
import { switchMap, take, withLatestFrom } from 'rxjs/operators';
import { getUserPreferences } from '../../store/reducers';
import { UserPreferenceState } from '../../store/reducers/user-preference.reducer';

@Injectable()
export class UserPreferenceHeaderInterceptor implements HttpInterceptor {
  constructor(
    @Inject(NYDUS_NETWORK_API_BASE_URL) private nydusNetworkUrl: string,
    private store: Store,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // This interceptor should only handle calls to Nydus Network
    const url = req.url;
    if (!url.startsWith(this.nydusNetworkUrl)) {
      return next.handle(req);
    }

    return this.store.select(getCoreState).pipe(
      withLatestFrom(this.store.select(getUserPreferences)),
      take(1),
      switchMap(
        ([{ auth }, { pointsAccountId }]: [CoreState, UserPreferenceState]) => {
          if (!auth.isLoggedIn || !pointsAccountId) {
            return next.handle(req);
          }

          // In the future we can abstract this logic out to it's own function but for now, we only care points account id
          // As a requirement for ANZ
          const userPreferenceHeader = `points_account_id=${pointsAccountId};`;

          const clonedReq = req.clone({
            headers: req.headers.set(
              'X-RD-Local-Preferences',
              userPreferenceHeader,
            ),
          });

          return next.handle(clonedReq);
        },
      ),
    );
  }
}
